import React, {useState,useEffect} from 'react';
import notify from "./notifier";
import OwlCarousel from 'react-owl-carousel';import { withRouter } from "react-router-dom";
import { Button, Container, Row, Col} from "reactstrap";
import MEDIA_URL from "../contants";


// export default function Casino(props) {
const Casino = (props) => {
    const [Carousal, setCarousal] = useState(false);
    const [casinoGame] = useState([
        // {
        //     providerName: "GT",
        //     gameCode: "",
        //     title: "Evolution",
        //     img: "evolution1.webp"
        // },
        {
            providerName: "GT",
            gameCode: "",
            title: "World Casino",
            img: "world-casino.png"  
        },
        {
            providerName: "GT",
            gameCode: "",
            title: "virtual Games",
            img: "virtualggames.png"  
        },
        {
            providerName: "EZ",
            title: "Ezugi",
            img: "ezugi.png"
        },
        // {
        //     providerName: "SPB",
        //     gameCode: "aviator",
        //     title: "Aviator",
        //     img: "aviator.webp"
        // },
        {
            providerName: "SN",
            title: "Supernova",
            img: "supernows.png"
        },
        {
            providerName: "QT",
            title: "Q Tech",
            img: "qtechh.png"
        },
        {
            providerName: "PG",
            title: "Power Games",
            img: "powergame.png"
        },
        // {
        //     providerName: "AWC",
        //     title: "AE Sexy",
        //     img: "asexy.webp"
        // },
        // {
        //     providerName: "PP",
        //     title: "Pragmatic Play",
        //     img: "pragmetic.webp"
        // },
        // {
        //     providerName: "BN",
        //     title: "One Touch",
        //     img: "onetouch.webp"
        // },
        // {
        //     providerName: "GT",
        //     gameCode: "",
        //     title: "Only Play",
        //     img: "oneplaycasino.webp"
        // },
    ])
    
    useEffect( () => {
        if(props.is_carousal){
            setCarousal(true)
        }
    });
    const showSupernowa = (data) => {
        const userToken = JSON.parse(localStorage.getItem("@access:token"));
        if (!userToken) {
          notify("Please Login first", "error", "top-right");
          return false;
        }
        let providerCode = data?.providerName;
        let gameCode = data?.gameCode ? data?.gameCode : "no";
        const url = window.location.origin + "/Casino/" + providerCode + "/" + gameCode;
        window.open(url, "_self");
      };
    const options = {
        loop: true,
        dots: false,
        autoplay: true,
        margin: 10,
        // nav: true,
        // navText:['<img src="left_icon.png" alt="" />','<img src="right_icon.png" alt="" />'],
        responsive: {
          0: {
            items: 3,
          },
          600: {
            items: 3,
          },
          1000: {
            items: 5,
          },
        }
    };
    return (
        <>
            {
                Carousal == true
                ?
                <>
                    <Row className="m-0">
                        <OwlCarousel className='portal-casino owl-theme' loop margin={10}  items={4} autoplay={true} dots={false}>
                            {
                                casinoGame.map((data, idx) => (
                                    <div key={idx} className='casino-iimg'>
                                    <img
                                        alt={data.title}
                                        title={data.title}
                                        className="r-im"
                                        onClick={() => showSupernowa(data)}
                                        src={`${MEDIA_URL}/casino-provider/${data.img}`}
                                    />
                                    </div>
                                ))
                            }
                        </OwlCarousel>
                    </Row>
                </>
                : 
                
                    <OwlCarousel className='portal-casino owl-theme' loop margin={10}  {...options}>
                        {
                            casinoGame.map((data, idx) => (
                                <li key={idx} className="pls  pl-item item" style={{cursor: "pointer"}}>
                                    <img
                                        alt={data.title}
                                        title={data.title}
                                        className="r-im"
                                        onClick={() => showSupernowa(data)}
                                        src={`${MEDIA_URL}/casino-provider/${data.img}`}
                                    />
                                    <p>{data.title}</p>
                                </li>
                            ))
                        }
                    </OwlCarousel>
            }
        </>
    )
}
export default withRouter(Casino);